import { getIn, useFormik, useFormikContext } from "formik";
import { IRenter } from "../../../../../../../types/renter.type";
import { useEffect, useState } from "react";
import InspectionRegister from "./field/InspectionRegister";

type Props = {
  data: IRenter;
};

export default function UnlinkVehicleModal(props: Props) {
  const renter = props.data;
  const label = renter.activationData.plan.label;
  const formikContext = useFormikContext();
  const registers = getIn(formikContext.values, "registers");
  const [isLicensePlateEmpty, setIsLicensePlateEmpty] = useState(false);

  const licensePlate = renter.activationData?.vehicle.licensePlate;

  // Atualiza o estado isLicensePlateEmpty apenas quando licensePlate muda
  useEffect(() => {
    setIsLicensePlateEmpty(!licensePlate);
  }, [licensePlate]);

  const handleCloseModal = () => {
    setIsLicensePlateEmpty(true);
  };

  const initialValues = {
    renterId: renter._id,
    renterName: renter.name,
    licensePlate: renter.activationData?.vehicle.licensePlate,
    vehicle: {
      _id: renter.activationData?.vehicle.id,
    },
    registers: [
      { type: 'Frente do veículo', content: '' },
      { type: 'Lateral direita do veículo', content: '' },
      { type: 'Lateral esquerda do veículo', content: '' },
      { type: 'Traseira do veículo', content: '' },
      { type: 'Odômetro', content: '' },
    ],
    returnReason: '',
    optionRepossesion: '',
  }

  const formik = useFormik({
    initialValues,
    onSubmit: async (data) => { data }
  })




  return (
    <section className="flex flex-col gap-4">
      <div>
        <InspectionRegister
          title="Inspeção Detalhada do Veículo"
          registers={registers}
          onAddRegister={() =>
            formik.setFieldValue("registers", [
              ...registers,
              { type: "", content: "", verified: false },
            ])
          }
          onRemoveRegister={(index) =>
            formik.setFieldValue(
              "registers",
              registers.filter((_, i) => i !== index)
            )
          }
          onCloseModal={handleCloseModal}
          isLicensePlateEmpty={isLicensePlateEmpty}
          action={"change"}
          plan={label}
        />
      </div>
    </section>
  );
}
